import React, { useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import Joi from "joi-browser";
import ThankYou from "./ThankYou";
import useForm from "../../app/hooks/useForm";
import useControls from "../../app/hooks/useControls";
import { useVerifySecQuestionMutation } from "../../app/store/authApiSlice";

const SecurityQuestion = ({
  handleQuestionBack,
  secQuestion,
  forgotType,
  urlData,
}) => {
  const [secMain, setSecMain] = useState(true);
  const [thankYou, setThankYou] = useState(false);

  const [verifySecQuestion] = useVerifySecQuestionMutation();

  const schema = {
    //answer: Joi.string().required().label("Security Answer"),
    // confirmAnswer: Joi.string().required().label("Confirm Security Answer"),
    captcha: Joi.string().required().label("Captcha"),
  };

  if (secQuestion !== undefined && secQuestion !== "") {
    secQuestion.map(
      (item, key) =>
      (schema[`answer_${item.id}`] = Joi.string()
        .required()
        .label(`Answer ${key + 1}`))
    );
  }

  const onCaptchaChange = (value) => {
    setStateData({ ...stateData, captcha: value });
  };

  const doSubmit = async () => {
    const secAnswer = [];
    secQuestion.map((item) => {
      const obj = {
        id: item.id,
        hintAnswer1: stateData[`answer_${item.id}`],
        type: forgotType,
      };
      secAnswer.push(obj);
    });
    const { data: result } = await verifySecQuestion(secAnswer);
    if (result === "success") {
      setSecMain(false);
      setThankYou(true);
    } else {
      const ansId = secQuestion[secQuestion.length - 1].id;
      setStateErrors({ ...stateErrors, [`answer_${ansId}`]: "Invalid Details" });
    }
  };

  const {
    stateData,
    setStateData,
    stateErrors,
    setStateErrors,
    handleChange,
    validate,
    handleSubmit,
  } = useForm(schema, doSubmit);

  const { renderInput } = useControls(
    stateData,
    stateErrors,
    handleChange,
    schema
  );

  return (
    <React.Fragment>
      {secMain && (
        <div className="row">
          <div className="col-md-12">
            <button
              className="btn btn-link pl-0 btn-sm"
              onClick={handleQuestionBack}
            >
              <i className="fa fa-long-arrow-left" aria-hidden="true"></i>
              Back
            </button>
          </div>
          {secQuestion !== "" &&
            secQuestion !== undefined &&
            secQuestion.map((item, key) => (
              <div className="col-md-12">
                <label htmlFor="" className="form-control-label">
                  Security Question {key + 1}
                </label>
                <p className="form-control form-group">
                  <b>{item.question1}</b>
                </p>
                {renderInput(
                  `answer_${item.id}`,
                  "Answer " + (key + 1),
                  "password"
                )}
              </div>
            ))}
          {/*

          <div className="col-md-12">
            {renderInput("confirmAnswer", "Confirm Answer", "password")}
          </div> */}
          <div className="col-md-12 form-group">
            <ReCAPTCHA
              sitekey="6Le08xsUAAAAAKC6Oglhe-haRVGzA8KTLUZ-jmEK"
              onChange={onCaptchaChange}
            />
          </div>
          <div className="col-md-12">
            <button
              className="btn btn-outline-default w-100"
              onClick={handleSubmit}
              disabled={!!validate()}
            >
              Submit
            </button>
          </div>
        </div>
      )}
      {thankYou && (
        <ThankYou forgotType={forgotType} urlData={urlData}></ThankYou>
      )}
    </React.Fragment>
  );
};

export default SecurityQuestion;
